export class OptionsValidator {
    constructor(gformSejour) {
        this.gform = gformSejour;
        this.wrapper = gformSejour.formWrapper;
        this.init();
    }

    init() {
        this.bindValidation();
    }

    bindValidation() {
        this.wrapper.addEventListener('change', (e) => {
            if (e.target.name === 'input_1.3') {
                this.validatePensionLimits();
            }

            if (e.target.name === 'input_30.3' || e.target.name === 'input_32.3') {
                this.validatePensionLimits();
            }
        });

        this.wrapper.addEventListener('input', (e) => {
            if (e.target.name === 'input_30.3' || e.target.name === 'input_32.3') {
                this.validatePensionLimits();
            }
        });
    }

    validatePensionLimits() {
        const maxParticipants = this.gform.state.participants;

        const adultInput = this.wrapper.querySelector('input[name="input_30.3"]');
        const childInput = this.wrapper.querySelector('input[name="input_32.3"]');

        if (adultInput) {
            const adultValue = parseInt(adultInput.value) || 0;
            if (adultValue > maxParticipants) {
                adultInput.value = maxParticipants;
                this.triggerChange(adultInput);
            }
            this.updateMaxAttribute(adultInput, maxParticipants);
        }

        if (childInput) {
            const childValue = parseInt(childInput.value) || 0;
            if (childValue > maxParticipants) {
                childInput.value = maxParticipants;
                this.triggerChange(childInput);
            }
            this.updateMaxAttribute(childInput, maxParticipants);
        }

        const totalPensions = (parseInt(adultInput?.value) || 0) + (parseInt(childInput?.value) || 0);
        if (totalPensions > maxParticipants) {
            this.showWarning(`Le nombre total de pensions ne peut pas dépasser ${maxParticipants} participants.`);
        } else {
            this.hideWarning();
        }

        this.updateQuantityButtonStates();
    }

    updateMaxAttribute(input, max) {
        input.setAttribute('max', max);

        const plusBtn = input.closest('.gf-quantity-control')?.querySelector('.gf-quantity-btn--plus');
        if (plusBtn) {
            const currentValue = parseInt(input.value) || 0;
            plusBtn.disabled = currentValue >= max;
        }
    }

    updateQuantityButtonStates() {
        const controls = this.wrapper.querySelectorAll('.gf-quantity-control');
        controls.forEach(control => {
            const input = control.querySelector('input');
            if (!input) return;

            const fieldName = input.name;
            if (!fieldName.includes('input_30.3') && !fieldName.includes('input_32.3')) return;

            const plusBtn = control.querySelector('.gf-quantity-btn--plus');
            const minusBtn = control.querySelector('.gf-quantity-btn--minus');

            if (plusBtn && minusBtn) {
                const value = parseInt(input.value) || 0;
                const max = this.gform.state.participants;
                const min = parseInt(input.getAttribute('min')) || 0;

                plusBtn.disabled = value >= max;
                minusBtn.disabled = value <= min;
            }
        });
    }

    showWarning(message) {
        let warning = this.wrapper.querySelector('.gf-pension-warning');
        if (!warning) {
            warning = document.createElement('div');
            warning.className = 'gf-pension-warning';
            warning.style.cssText = `
                background: rgba(254, 72, 109, 0.1);
                color: var(--color-danger);
                padding: 0.75rem 1rem;
                border-radius: var(--radius-medium);
                font-size: 0.875rem;
                margin-top: 0.5rem;
            `;

            const pensionSection = this.wrapper.querySelector('#field_' + this.gform.formId + '_31');
            if (pensionSection) {
                pensionSection.appendChild(warning);
            }
        }
        warning.textContent = message;
    }

    hideWarning() {
        const warning = this.wrapper.querySelector('.gf-pension-warning');
        if (warning) {
            warning.remove();
        }
    }

    triggerChange(input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
}
